// extracted by mini-css-extract-plugin
module.exports = {"header":"_3PGzLb-9xmAU2EPifwu6Fl","dialog":"_3t0XY36cQ6N6FVX1RF4dvU","no-button":"_3lRWg8KN9SJsp_cAfChj7y","yes-button":"_1lhp0sA-M6V2wCGCarMa-5"};